<template>
  <template v-if="Array.isArray(videos) && videos.length">
    <div
      ref="videoCategoryRef"
      class="max-h-0 overflow-hidden duration-500 transition-all"
      :style="switchHeightStyle"
    >
      <div class="my-2">
        <table class="w-full table-fixed">
          <tr
            v-for="video in videos"
            :key="video.id"
            @click="router.push({ name: 'VideoDetails', params: { video_id: video.id } })"
            class="hover:bg-mentalncSuperLight hover:shadow-md cursor-pointer border border-slate-300"
            :class="switchColor(video.id)"
          >
            <td class="px-4 py-2">
              <div class="flex items-center">
                <template v-if="Array.isArray(video.video_completions) && video.video_completions.length">
                  <img class="w-6 md:w-7" src="@/assets/images/completed.png" alt="済"/>
                </template>
                <template v-else>
                  <img class="w-6 md:w-7" src="@/assets/images/round.png" alt="未済"/>
                </template>
                <div class="text-sm md:text-base font-medium text-gray-500 truncate ml-3">{{ video.title }}</div>
              </div>
            </td>
          </tr>
        </table>
      </div>
    </div>
  </template>
</template>

<script lang="ts">
import { defineComponent, ref, computed, PropType } from 'vue'
import { useRouter, useRoute } from 'vue-router'
import { VideoAttributes } from '@/types/models/video'

export default defineComponent({
  props: {
    isOpen: {
      type: Boolean,
      'default': () => (false),
    },
    videos: {
      type: Object as PropType<VideoAttributes[] | undefined>,
      'default': () => ([]),
    },
  },
  setup(props) {
    const router = useRouter()
    const route = useRoute()
    const videoCategoryRef = ref<HTMLElement | undefined>(undefined)

    const switchHeightStyle = computed(() => {
      const maxHeight = props.videos ? props.videos.length * 45 + 20 : 0
      return props.isOpen ? `max-height: ${maxHeight}px` : ''
    })

    const switchColor = (videoId: number) => {
      return route.params.video_id == `${videoId}` ? 'bg-mentalncSuperLight shadow-md' : ''
    }

    return {
      router,
      switchHeightStyle,
      videoCategoryRef,
      switchColor
    }
  },
})
</script>
